import {yellow} from '@material-ui/core/colors';

const prefersDarkMode = ('@media(prefers-color-scheme: dark)');
export const style = theme => ({
    paper: {
        boxShadow: 'none',
        borderBottom: '1px solid rgba(0,0,0,0.08)',
        borderRadius: 0,
        padding: 20,
    },
    basePicker: {
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
    },
    picker: {
        // height: '100%',
        // maxHeight: 345,
        flex: 1,
        overflow: 'hidden',
        '& .MuiPickersStaticWrapper-staticWrapperRoot': {
            backgroundColor: 'transparent',
            width: '100%',
            '& .MuiPickersBasePicker-container': {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            },
            '& .MuiPickersToolbar-toolbar': {
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                backgroundColor: theme.palette.type === 'light' && '#440099'
            }
        }
    },
    day: {
        width: 36,
        height: 36,
        fontSize: theme.typography.caption.fontSize,
        margin: "0 2px",
        color: "inherit",
        // '@media (prefers-color-scheme: dark)': {
        //   color: "black"
        // }
    },
    customDayHighlight: {
        position: "absolute",
        top: 0,
        bottom: 0,
        left: "2px",
        right: "2px",
        border: `1px solid ${theme.palette.secondary.main}`,
        borderRadius: "50%"
    },
    nonCurrentMonthDay: {
        color: theme.palette.text.disabled
    },
    highlightNonCurrentMonthDay: {
        color: "#6A6A6A"
    },
    highlight: {
        background: theme.palette.primary.main + ' !important',
        borderRadius: "50%",
        color: theme.palette.text.primary,
        fontWeight: 'bold',
        [prefersDarkMode]: {
            color: theme.palette.text.primary.light
        }
    },
    today: {
        border: `1px solid ${theme.palette.secondary.main}`,
        borderRadius: "50%",
    },
    high: {
        [prefersDarkMode]: {
            color: theme.palette.common.black
        },
        fontWeight: 'bold',
        borderRadius: "50%",
        background: yellow[200] + ' !important',
    },
    low: {
        [prefersDarkMode]: {
            color: theme.palette.common.black
        },
        fontWeight: 'bold',
        borderRadius: "50%",
        background: `#D92D20 !important`,
    },
    feriado: {
        [prefersDarkMode]: {
            color: theme.palette.common.black
        },
        fontWeight: 'bold',
        borderRadius: "50%",
        background: yellow['900'] + ' !important',
    },
    ferias: {
        [prefersDarkMode]: {
            color: theme.palette.common.black
        },
        fontWeight: 'bold',
        borderRadius: "50%",
        background: `#4c12aa !important`,
    },
    equal: {
        [prefersDarkMode]: {
            color: theme.palette.common.black
        },
        fontWeight: 'bold',
        borderRadius: "50%",
        background: `#2D9B52 !important`,
    },
    hollyday: {
        [prefersDarkMode]: {
            color: theme.palette.common.black
        },
        fontWeight: 'bold',
        borderRadius: "50%",
        background: `#5310c7 !important`,
    },
    border: {
        width: 36,
        height: 36,
        boxSizing: 'border-box',
        border: `2px solid ${theme.palette.primary.main} !important`,
        color: theme.palette.common.black,
        '& .MuiIconButton-label': {
            marginTop: -2
        },
        '&:hover': {
            background: theme.palette.primary.main,
            color: theme.palette.common.white,
            [prefersDarkMode]: {
                color: theme.palette.common.black
            },
        }
    },
    ToolbarMainCalendar: {
        toolbar: {
            flexDirection: 'row',
            alignItems: 'center',
        },
        toolbarLandscape: {
            padding: 0,
        },
        dateLandscape: {
            marginRight: 16,
        },
    },
    progressBar: {
        width: '100%',
        padding: '10px 5%',
        [theme.breakpoints.up('sm')]: {
            padding: '20px 5%',
        }
    },
    feriadoLabel: {
        fontSize: '0.7em',
        position: 'absolute',
        bottom: 4,
        fontWeight: 600,
    },
    feriasLabel: {
        fontSize: '0.7em',
        position: 'absolute',
        bottom: 4,
        fontWeight: 600,        
    },
    legendCalendar:{
        width: '100%',
        padding: '10px 5%',
    },
    divLegend :{
        display: 'inline-block',
        fontSize:'11px',
        padding: '5px'
     },
     yellowCircle: {
        background: yellow[200] + ' !important',
        borderRadius: '50%',
        padding:'9px',
        width: '25px',
        height: '25px',
        border: 'none',
        top: 0,
    },
    greenCircle: {
        background: `#2D9B52 !important`,
        borderRadius: '50%',
        bottom:'5px',
        padding: '9px',
        width: '25px',
        height: '25px',
        border: 'none',
    },
    redCircle: {
        background: `#D92D20 !important`,
        borderRadius: '50%',
        bottom:'5px',
        padding: '9px',
        width: '25px',
        height: '25px',
        border: 'none',
    },
    purpleCircle: {
        background: `#5310c7 !important`,
        borderRadius: '50%',
        bottom:'5px',
        padding: '9px',
        width: '25px',
        height: '25px',
        border: 'none',
    },
    darkPurpleCircle: {
        background: `#4c12aa !important`,
        borderRadius: '50%',
        bottom:'5px',
        padding: '9px',
        width: '25px',
        height: '25px',
        border: 'none',
    },
    blueCircle: {
        bottom: '10%',
        background: `#440099 !important`,
        borderRadius: '50%',
        bottom:'5px',
        padding: '9px',
        width: '25px',
        height: '25px',
        border: 'none'
    },
    whiteCircle: {
        bottom: '10%',
        background: 'transparent',
        borderRadius: '50%',
        bottom:'5px',
        padding: '9px',
        width: '25px',
        height: '25px',
        border: '1px solid grey',
    },
    tableCell: {
        textAlign: 'center'
    }
});
